import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "custom-section",
  "data-preset-category": "custom"
}
const _hoisted_2 = {
  class: "muted",
  role: "status"
}
const _hoisted_3 = {
  key: 0,
  role: "alert"
}
const _hoisted_4 = {
  key: 1,
  class: "muted"
}
const _hoisted_5 = ["data-preset-id"]
const _hoisted_6 = { class: "fields" }
const _hoisted_7 = { class: "muted" }
const _hoisted_8 = { class: "subhead" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = { class: "fields" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "subhead" }
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "table-scroll" }
const _hoisted_17 = ["value", "onInput"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "empty"
}
const _hoisted_21 = ["data-preset-id"]
const _hoisted_22 = {
  key: 0,
  class: "muted"
}
const _hoisted_23 = { class: "table-name" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { class: "muted" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "subhead" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "fields" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = ["value"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "subhead" }
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = {
  key: 1,
  class: "muted"
}
const _hoisted_36 = {
  key: 2,
  class: "table-scroll"
}
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "preset-footer" }
const _hoisted_40 = ["disabled"]

import StudioSelectField from "../StudioSelectField.vue";
import TypedValueInput from "../TypedValueInput.vue";
import { computed } from "vue";
import { createCustomTable, createCustomField, createCustomRecord, mergeCustomPresets, type CustomPresetTable } from "./customPresets";
import { PUBLIC_EVENT_PARAM_TYPES } from "./publicEventPresets";

export default /*@__PURE__*/_defineComponent({
  __name: 'CustomPresetSection',
  props: {
    presets: {},
    systemPresets: {},
    ready: { type: Boolean },
    status: {},
    error: {}
  },
  emits: ["retry"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const customTables = computed(() => props.presets.filter(table => !props.systemPresets.some(base => base.id === table.extends)));
const mergedSystem = computed(() => mergeCustomPresets(props.systemPresets, props.presets).slice(0, props.systemPresets.length));
function extension(table: CustomPresetTable) { return props.presets.find(item => item.extends === table.id); }
function ensureExtension(table: CustomPresetTable) {
  let item = extension(table);
  if (!item) {
    props.presets.push({ ...createCustomTable(), name: table.name, extends: table.id });
    item = extension(table)!;
  }
  return item;
}
function isSystemField(table: CustomPresetTable, id: string) { return props.systemPresets.find(base => base.id === table.id)?.fields.some(field => field.id === id); }
function isSystemRow(table: CustomPresetTable, id: string) { return props.systemPresets.find(base => base.id === table.id)?.records.some(row => row.id === id); }
function setCell(table: CustomPresetTable, rowId: string, fieldId: string, value: string) {
  if (isSystemRow(table, rowId) && isSystemField(table, fieldId)) return;
  const extra = ensureExtension(table);
  let row = extra.records.find(item => item.id === rowId);
  if (!row) {
    extra.records.push({ id: rowId, name: table.records.find(item => item.id === rowId)?.name ?? "", values: {} });
    row = extra.records.find(item => item.id === rowId)!;
  }
  row.values[fieldId] = value;
}
function renameRow(table: CustomPresetTable, rowId: string, event: Event) {
  const row = extension(table)?.records.find(item => item.id === rowId);
  if (row && !isSystemRow(table, rowId)) row.name = (event.target as HTMLInputElement).value;
}
function deleteRow(table: CustomPresetTable, rowId: string) {
  const extra = extension(table);
  if (extra && !isSystemRow(table, rowId)) extra.records = extra.records.filter(row => row.id !== rowId);
}
function deleteTable(table: CustomPresetTable) { props.presets.splice(props.presets.indexOf(table), 1); }
function removeField(table: CustomPresetTable, id: string) {
  table.fields = table.fields.filter(field => field.id !== id);
  for (const record of table.records) delete record.values[id];
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("h3", null, "自定义配置"),
        _createElementVNode("p", null, "先定义字段，再添加记录。公共事件可引用任意一个字段作为参数来源。")
      ])
    ], -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.status), 1),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(__props.error) + " ", 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
          }, "重试")
        ]))
      : _createCommentVNode("", true),
    _cache[19] || (_cache[19] = _createElementVNode("h4", null, "系统配置类别", -1)),
    (!__props.systemPresets.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "暂无系统配置。"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mergedSystem.value, (table) => {
      return (_openBlock(), _createElementBlock("article", {
        key: table.id,
        "data-preset-id": table.id,
        tabindex: "-1"
      }, [
        _createElementVNode("h4", null, _toDisplayString(table.name), 1),
        _cache[9] || (_cache[9] = _createElementVNode("h4", null, "系统字段 · 只读", -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields.filter(item => isSystemField(table, item.id)), (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.id,
              class: "field-row"
            }, [
              _createElementVNode("span", null, _toDisplayString(field.name || '未命名字段'), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(PUBLIC_EVENT_PARAM_TYPES).find(type => type.value === field.type)?.label), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", null, "自定义字段", -1)),
          _createElementVNode("button", {
            disabled: !__props.ready,
            onClick: ($event: any) => (ensureExtension(table).fields.push(_unref(createCustomField)()))
          }, "＋ 添加自定义字段", 8, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(extension(table)?.fields.filter(item => !isSystemField(table, item.id)) || [], (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.id,
              class: "field-row"
            }, [
              _createElementVNode("label", null, [
                _cache[3] || (_cache[3] = _createTextVNode("字段名称", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((field.name) = $event),
                  "aria-label": "自定义字段名称"
                }, null, 8, _hoisted_11), [
                  [_vModelText, field.name]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[4] || (_cache[4] = _createTextVNode("数据类型", -1)),
                _createVNode(StudioSelectField, {
                  modelValue: field.type,
                  "onUpdate:modelValue": ($event: any) => ((field.type) = $event),
                  "aria-label": "自定义字段类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PUBLIC_EVENT_PARAM_TYPES), (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type.value,
                        value: type.value
                      }, _toDisplayString(type.label), 9, _hoisted_12))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("button", {
                class: "delete",
                onClick: ($event: any) => (removeField(ensureExtension(table), field.id))
              }, "删除字段", 8, _hoisted_13)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[5] || (_cache[5] = _createElementVNode("h4", null, "配置记录", -1)),
          _createElementVNode("button", {
            disabled: !__props.ready || !table.fields.length,
            onClick: ($event: any) => (ensureExtension(table).records.push(_unref(createCustomRecord)()))
          }, "＋ 添加自定义记录", 8, _hoisted_15)
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "muted" }, "系统记录的名称和系统字段值只读；新增字段的值可以填写。自定义记录可编辑全部字段。", -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("th", null, "记录名称", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields, (field) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: field.id
                  }, [
                    _createTextVNode(_toDisplayString(field.name || '未命名字段'), 1),
                    _createElementVNode("small", null, _toDisplayString(isSystemField(table, field.id) ? '系统字段' : '自定义字段'), 1)
                  ]))
                }), 128)),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, "操作", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.records, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.id
                }, [
                  _createElementVNode("td", null, [
                    (isSystemRow(table, row.id))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(row.name), 1),
                          _cache[8] || (_cache[8] = _createElementVNode("small", null, "系统记录", -1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          value: row.name,
                          "aria-label": "记录名称",
                          onInput: ($event: any) => (renameRow(table, row.id, $event))
                        }, null, 40, _hoisted_17))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields, (field) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: field.id
                    }, [
                      (isSystemRow(table, row.id) && isSystemField(table, field.id))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(row.values[field.id]), 1))
                        : (_openBlock(), _createBlock(TypedValueInput, {
                            key: 1,
                            disabled: !__props.ready,
                            "model-value": row.values[field.id] || '',
                            "value-type": field.type,
                            "aria-label": field.name || '字段值',
                            "onUpdate:modelValue": ($event: any) => (setCell(table, row.id, field.id, $event))
                          }, null, 8, ["disabled", "model-value", "value-type", "aria-label", "onUpdate:modelValue"]))
                    ]))
                  }), 128)),
                  _createElementVNode("td", null, [
                    (!isSystemRow(table, row.id))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "delete",
                          onClick: ($event: any) => (deleteRow(table, row.id))
                        }, "删除", 8, _hoisted_19))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ], 8, _hoisted_5))
    }), 128)),
    _cache[20] || (_cache[20] = _createElementVNode("h4", null, "自定义配置类别", -1)),
    (__props.ready && !customTables.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, "例如创建「角色配置」，添加 GUID、技能 ID、称号等字段，再录入每个角色的数据。"))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customTables.value, (table) => {
      return (_openBlock(), _createElementBlock("article", {
        key: table.id,
        "data-preset-id": table.id,
        tabindex: "-1"
      }, [
        (table.extends)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, "原系统类别已移除，已保留此类别的自定义字段和记录。"))
          : _createCommentVNode("", true),
        _createElementVNode("header", null, [
          _createElementVNode("label", _hoisted_23, [
            _cache[11] || (_cache[11] = _createTextVNode("配置类别名称", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((table.name) = $event),
              placeholder: "例如：角色配置",
              "aria-label": "配置类别名称"
            }, null, 8, _hoisted_24), [
              [_vModelText, table.name]
            ])
          ]),
          _createElementVNode("span", _hoisted_25, _toDisplayString(table.fields.length) + " 个字段 · " + _toDisplayString(table.records.length) + " 条记录", 1),
          _createElementVNode("button", {
            class: "delete",
            onClick: ($event: any) => (deleteTable(table))
          }, "删除类别", 8, _hoisted_26)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[12] || (_cache[12] = _createElementVNode("h4", null, "字段定义", -1)),
          _createElementVNode("button", {
            onClick: ($event: any) => (table.fields.push(_unref(createCustomField)()))
          }, "＋ 添加字段", 8, _hoisted_28)
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.id,
              class: "field-row"
            }, [
              _createElementVNode("label", null, [
                _cache[13] || (_cache[13] = _createTextVNode("字段名称", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => ((field.name) = $event),
                  placeholder: "例如：角色 GUID",
                  "aria-label": "字段名称"
                }, null, 8, _hoisted_30), [
                  [_vModelText, field.name]
                ])
              ]),
              _createElementVNode("label", null, [
                _cache[14] || (_cache[14] = _createTextVNode("数据类型", -1)),
                _createVNode(StudioSelectField, {
                  modelValue: field.type,
                  "onUpdate:modelValue": ($event: any) => ((field.type) = $event),
                  "aria-label": "字段类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PUBLIC_EVENT_PARAM_TYPES), (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type.value,
                        value: type.value
                      }, _toDisplayString(type.label), 9, _hoisted_31))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("button", {
                class: "delete",
                onClick: ($event: any) => (removeField(table, field.id))
              }, "删除字段", 8, _hoisted_32)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_33, [
          _cache[15] || (_cache[15] = _createElementVNode("h4", null, "配置记录", -1)),
          _createElementVNode("button", {
            disabled: !table.fields.length,
            onClick: ($event: any) => (table.records.push(_unref(createCustomRecord)()))
          }, "＋ 添加记录", 8, _hoisted_34)
        ]),
        (!table.fields.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_35, "添加字段后即可录入记录。"))
          : (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("th", null, "记录名称", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields, (field) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: field.id
                      }, [
                        _createTextVNode(_toDisplayString(field.name || '未命名字段'), 1),
                        _createElementVNode("small", null, _toDisplayString(_unref(PUBLIC_EVENT_PARAM_TYPES).find(type => type.value === field.type)?.label), 1)
                      ]))
                    }), 128)),
                    _cache[17] || (_cache[17] = _createElementVNode("th", null, "操作", -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.records, (row, rowIndex) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.id
                    }, [
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((row.name) = $event),
                          "aria-label": "记录名称",
                          placeholder: "显示在下拉列表中的名称"
                        }, null, 8, _hoisted_37), [
                          [_vModelText, row.name]
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(table.fields, (field) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: field.id
                        }, [
                          _createVNode(TypedValueInput, {
                            modelValue: row.values[field.id],
                            "onUpdate:modelValue": ($event: any) => ((row.values[field.id]) = $event),
                            "value-type": field.type,
                            "aria-label": field.name || '字段值',
                            placeholder: "输入值"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "value-type", "aria-label"])
                        ]))
                      }), 128)),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "delete",
                          onClick: ($event: any) => (table.records.splice(rowIndex, 1))
                        }, "删除", 8, _hoisted_38)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
      ], 8, _hoisted_21))
    }), 128)),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("button", {
        disabled: !__props.ready,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.presets.push(_unref(createCustomTable)())))
      }, "＋ 新建配置类别", 8, _hoisted_40)
    ])
  ]))
}
}

})